import {v4 as uuidv4} from "uuid";
import {Store} from 'vuex';
import {App, Component} from 'vue';

export interface ModalInitOptions {
    app: App,
    store: Store<any>
    components: {
        message: Component
        confirm: Component
    }
}

export interface ModalOptions<T = any> {
    component: Component<T>,
    props?: T
    sm?: boolean
    md?: boolean
    lg?: boolean
    xl?: boolean
    fluid?: boolean
}

export interface ModalInstance<T = any> {
    id: string
    component: Component<T>,
    sm?: boolean
    md?: boolean
    lg?: boolean
    xl?: boolean
    fluid?: boolean
    props?: T
    resolve: (data: T) => void
    reject: (data: any) => void
}

export interface ModalInterface {
    confirm: <T>(message: string) => Promise<T>
    message: <T>(message: string) => Promise<T>
    show: <T>(instance: ModalOptions) => Promise<T>
}

export function create(options: ModalInitOptions): ModalInterface {

    const components: Map<string, Component> = new Map()

    return {
        confirm<T>(message: string): Promise<T> {

            return this.show({component: options.components.confirm, props: {message}});
        },
        message<T>(message: string): Promise<T> {

            return this.show({component: options.components.message, props: {message}});
        },
        show<T>(modalOptions: ModalOptions): Promise<T> {

            if (!components.has(modalOptions.component.name as string)) {

                options.app.component(modalOptions.component.name as string, modalOptions.component);
                components.set(modalOptions.component.name as string, modalOptions.component);
            }

            return new Promise(async (resolve, reject): Promise<void> => {

                const index = options.store.getters['modals/items'].length;
                const modal: ModalInstance = {
                    id: uuidv4(),
                    sm: modalOptions.sm ?? false,
                    md: modalOptions.md ?? false,
                    lg: modalOptions.lg ?? false,
                    xl: modalOptions.xl ?? false,
                    fluid: modalOptions.fluid ?? false,
                    component: modalOptions.component,
                    props: modalOptions.props,
                    resolve(result: T) {

                        resolve(result);
                        options.store.dispatch('modals/splice', {index, count: 1});
                    },
                    reject,
                }

                await options.store.dispatch('modals/push', modal);
            });
        }
    }
}